import JSEncrypt from "jsencrypt";

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
MEgCQQCMHQCSw4sGmjlF7qIwlTAYr1ZblQUPhIW1yLalpL/ze2Z7hsSU/fykvNFf
54AaPaGT2ATAH9w7trfrnOnPEC27AgMBAAE=
-----END RSA PUBLIC KEY-----`
const privateKey = `-----BEGIN RSA PRIVATE KEY-----
MIIBPQIBAAJBAIwdAJLDiwaaOUXuojCVMBivVluVBQ+EhbXItqWkv/N7ZnuGxJT9
/KS80V/ngBo9oZPYBMAf3Du2t+uc6c8QLbsCAwEAAQJAQzkK9F8zDYji36V9VVfO
ipldEnVtxyMqz6urzc88IRWPLOcfw3631422+2nG9AAhcDwIw7YgyQgd+cTwAJAw
kQIjAK7sVPqlSYw8JJAGEZsuVgewk11lU0rR+Q+KcXXOpeVlzVkCHwDNDkWpVbJ+
7NTxjQdY6ZJt5dHV8p231ynxIUYYzTMCInD4pTFzinqNZTe3E6vbUyiIO8R36kFK
NsZ4rSpemfn7s5ECHwDHEfv/EPtgzXtNpaRkZR2LI3o7QnZra6+EMNFkcpECIwCR
ZcCtWXPlbZqsXR4B60k8gmrYLX9Z5DOhIMeE7P5kNJut
-----END RSA PRIVATE KEY-----`

// 加密
export function encrypt(text){
    const encryptor = new JSEncrypt() 
    encryptor.setPublicKey(publicKey) // 设置公钥
    return encryptor.encrypt(text) // 对数据进行加密
}

// 解密
export function decrypt(text){
    const encryptor = new JSEncrypt()
    encryptor.setPrivateKey(privateKey) // 设置私钥
    return encryptor.decrypt(text) // 对数据进行解密
}
